(function ($) {
	'use strict';

	$(function () {
		const productGrids = document.querySelectorAll('.js-product-grid');

		function showProducts(items, button, initial = false) {
			const url = new URL(window.location.href);
			const urlParams = new URLSearchParams(url.search);

			if (urlParams.has('loaded') && urlParams.get('loaded') === 'true') {
				items.forEach((item, key) => {
					const animationKey = key + 8;

					setTimeout(() => {
						item.classList.remove('product-grid__item--hidden');
						item.classList.add('a-keyframe-fade-in-up');
					}, animationKey * 200);
				});

				button.classList.add('product-grid__more--hidden');
				url.searchParams.set('loaded', 'true');
				history.pushState({}, "", url);
			} else {
				items.forEach((item, key) => {
					item.classList.add('product-grid__item--hidden');
					item.classList.remove('a-keyframe-fade-in-up');
				});

				button.classList.remove('product-grid__more--hidden');
				url.searchParams.delete('loaded');
				history.pushState({}, "", url);
			}
		}

		productGrids.forEach(grid => {
			const loadMoreButton = grid.querySelector('.js-product-grid-more');
			const hiddenItems = grid.querySelectorAll('.js-product-grid-item');
			const url = new URL(location);

			loadMoreButton.addEventListener('click', (e) => {
				e.preventDefault();

				loadMoreButton.classList.add('product-grid__more--hidden');

				url.searchParams.set('loaded', 'true');
				history.pushState({}, "", url);

				hiddenItems.forEach((item, key) => {
					setTimeout(() => {
						item.classList.remove('product-grid__item--hidden');
						item.classList.add('a-keyframe-fade-in-up');
					}, key * 200);
				});
			});

			showProducts(hiddenItems, loadMoreButton, true);

			addEventListener('popstate', () => {
				showProducts(hiddenItems, loadMoreButton);
			});
		});
	});
})(jQuery, document, window);
